import { useState, useEffect } from "react";
import { loadShifRosterEmployeeListByDepartmentID } from "../services/shiftService";
import { loadRequestIndentNumberlist } from "../services/requestIndentService";



const useRequestIndentNumberListByDepartment = (editShiftAssignmentID, selectedDepartmentID) => {
    const [requestIndentNumberList, setRequestIndentNumberList] = useState([]);
    const [selectedRequestIndentNumberList, setSelectedRequestIndentNumberList] = useState([]);
    const [selectedRequestIndentNumberListID, setSelectedRequestIndentNumberListID] = useState([]);
    const [isShiftRoasterDataLoaded, setIsShiftRoasterDataLoaded] = useState(false);


    const fetchRequestNumberList = async (selectedID = null, mode, requestid = null) => {
        const para = {
            p_company_id: localStorage.getItem("companyid"),
            p_plant_id: 1,
            p_id_department: selectedID,
            p_module_name: mode,
        };

        if (selectedID && selectedID !== 0) {
            try {
                //loadShifRosterEmployeeListByDepartmentID
                const data = await loadRequestIndentNumberlist(para);
                if (data && data.length > 0) {
                    setRequestIndentNumberList(data);

                    const initialDepartment = data.find((dept) => dept.id_request === requestid);

                    if (initialDepartment) { // ✅ Corrected check
                        setSelectedRequestIndentNumberList(initialDepartment);
                        setSelectedRequestIndentNumberListID(initialDepartment.id_request);
                        setIsShiftRoasterDataLoaded(true);
                    }
                }
                else {
                    setRequestIndentNumberList([]);
                    setSelectedRequestIndentNumberList(null);
                    setSelectedRequestIndentNumberListID(null);
                    setIsShiftRoasterDataLoaded(false);
                }
            } catch (error) {
                // CallMessage("error", error.message, "Error");
            }
        }
        else {
           
            // setSelectedRequestIndentNumberList(null);
            // setSelectedRequestIndentNumberListID(null);
            // setIsShiftRoasterDataLoaded(false);
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isShiftRoasterDataLoaded && editShiftAssignmentID === 0) {
            fetchRequestNumberList();
        }
    }, [isShiftRoasterDataLoaded, editShiftAssignmentID]);

    // Function to load department based on selected ID 

    const loadIndentNumbersByDepartmentID = async (selectedID, mode, requestid) => {
        await fetchRequestNumberList(selectedID, mode, requestid);
    };

    return {
        requestIndentNumberList,
        setRequestIndentNumberList,
        selectedRequestIndentNumberList,
        selectedRequestIndentNumberListID,
        setSelectedRequestIndentNumberList,
        setSelectedRequestIndentNumberListID,
        loadIndentNumbersByDepartmentID,
    };
};

export default useRequestIndentNumberListByDepartment;